import React from 'react';
import * as serviceWorkerRegistration from '../../serviceWorkerRegistration';
import { useEffect, useState } from 'react';

export default function ServiceWorkerProcess() {
  const [swInitialized, setSwInitialized] = useState(false);
  const [swUpdated, setSwUpdated] = useState(false);
  const [swRegistration, setSwRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(
    () => {
      const config: serviceWorkerRegistration.Config = {
        onUpdate: (registration) => {
          console.log('[serviceworker] update available...', registration);
          setSwUpdated(true);
          setSwRegistration(registration);
        },
        onSuccess: (registration) => {
          console.log('[serviceworker] update installed successfully', registration);
          setSwInitialized(true);
        }
      };
      // If you want your app to work offline and load faster, you can change
      // unregister() to register() below. Note this comes with some pitfalls.
      // Learn more about service workers: https://cra.link/PWA
      // serviceWorkerRegistration.unregister();
      if (true) {
        serviceWorkerRegistration.register(config);
      } else {
        serviceWorkerRegistration.unregister();
      }
    },
    [],
  );
  const updateServiceWorker = () => {
    const registrationWaiting = swRegistration ? swRegistration.waiting : null;
    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
      registrationWaiting.addEventListener('statechange', e => {
        // if (e.target.state === 'activated') {
          window.location.reload();
        // }
      });
    }
  };
  if (swUpdated) {
    return (
      <div style={{ position: 'absolute', width: '100%', height: '50px', backgroundColor: 'red', color: 'white' }}>
        Une nouvelle version est disponible (v2) <button onClick={updateServiceWorker}>Mettre à jour</button> ({swInitialized})
      </div>
    );
  }
  return (<div />);
}
